import styled from "styled-components";

export const VideoTileFooterSectionDefaultBox = styled.div<{width?: string;}>`
    width: ${({width}) => width ? width : "auto"};
    margin-right: 1rem;
`;
